/**
 * Bank Balances page for the Entities scope.
 *
 * Renders BankBalancesSection with scope="entities" and reacts to the
 * entity selector in the sidebar (selectedEntity from useEntityStore).
 */

import { DashboardLayout } from '../components/DashboardLayout';
import { BankBalancesSection } from '../components/BankBalancesSection';
import { useEntityStore } from '../store';

export function BankBalancesPage({ embedded, onAccountClick } = {}) {
  var selectedEntity = useEntityStore(function (s) { return s.selectedEntity; });

  var content = (
      <div className="space-y-6" data-testid="bank-balances-page">
        <h1 className="text-3xl font-bold tracking-tight">Bank Balances</h1>
        <BankBalancesSection
          scope="entities"
          entityId={selectedEntity}
          onAccountClick={onAccountClick}
        />
      </div>
  );

  if (embedded) return content;

  return (
    <DashboardLayout>
      {content}
    </DashboardLayout>
  );
}

export function BankBalancesPageContent(props) {
  return <BankBalancesPage embedded {...props} />;
}
